import clsx from 'clsx';

import {
  formatDate,
  getMatchStatus,
} from '@/modules/players/v2/tabs/overview/TournamentResults/utils';
import { PlayerLiveGameStatusData } from '@/types/players.types';

interface MatchInfoProps {
  match: PlayerLiveGameStatusData;
}

const MatchInfo = ({ match }: MatchInfoProps) => {
  const { date } = formatDate({
    DateOfActivity: match.DateOfActivity,
    DateStart: match.DateStart,
    DateFinish: match.DateFinish,
  });

  const status = getMatchStatus(match);
  const medalWinnerRow =
    match.InBracketType === 'B' || match.InBracketType === 'GS' || match.InBracketType === 'GS2';

  return (
    <div
      className={clsx(
        'flex w-full flex-row items-center justify-between border-b px-3 py-2 sm:h-[128px] sm:w-[160px] sm:flex-col sm:items-start sm:justify-center sm:border-none sm:py-0',
        medalWinnerRow ? 'border-white' : 'border-gray-200'
      )}
    >
      <p className='text-sm text-gray-800 sm:mb-2'>Match #{match.DisplayMatchNumber}</p>
      <div className='flex h-full flex-row items-center sm:h-auto sm:flex-col sm:items-start'>
        <p className='self-start text-sm text-gray-800 sm:mb-1 sm:mr-0'>{date}</p>
        {status ? (
          <p className='line-clamp-1 text-xs text-gray-600 sm:mt-1' title={status}>
            {status}
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default MatchInfo;
